<script>
    import { onMount, onDestroy, tick } from 'svelte';
    import { executeClient } from 'api/rage';
    import { setView } from '../../../../../../../views/player/hudevo/ipad/components/fractions/data.js';
    import BeatCapture from '@/views/player/captures/BeatCapture.svelte';
    import InfoCapture from '@/views/player/captures/InfoCapture.svelte';
    import NotificationCapture from '@/views/player/captures/NotificationCapture.svelte';

    let squaresInfo = [];
    let myFractionName = '';
    let countSquares = 0;
    let avaibleAttacks = 3;
    let avaibleDefends = 3;

    let mapAreaEl;
    let _mapDiv = null;
    let _leafMap = null;
    let _markers = [];
    let mapShown = false;

    let showBeat = false;
    let showInfo = false;
    let showNotif = false;

    let beatData = {
        idSquare: 0, territoryUnderControl: '',
        hour: 0, minute: 0, countMembers: 2,
        armor: false, resist: false, calibreIndex: 0,
        selectedMembers: [], nonSelectedMembers: []
    };
    let infoData = {
        x: 0, y: 0, idSquare: 0, isOwner: false,
        attackGangName: '', defendGangName: '',
        countMembers: 1, calibreIndex: 0, startDate: ''
    };

    const SQUARE_POSITIONS = [
        {id:1,  lat:-1639.28, lng:45.70},   {id:2,  lat:-1639.28, lng:160.70},
        {id:3,  lat:-1639.28, lng:275.70},  {id:4,  lat:-1639.28, lng:390.70},
        {id:5,  lat:-1639.28, lng:505.70},
        {id:6,  lat:-1754.28, lng:-299.30}, {id:7,  lat:-1754.28, lng:-184.30},
        {id:8,  lat:-1754.28, lng:-69.30},  {id:9,  lat:-1754.28, lng:45.70},
        {id:10, lat:-1754.28, lng:160.70},  {id:11, lat:-1754.28, lng:275.70},
        {id:12, lat:-1754.28, lng:390.70},  {id:13, lat:-1754.28, lng:505.70},
        {id:14, lat:-1869.28, lng:-299.30}, {id:15, lat:-1869.28, lng:-184.30},
        {id:16, lat:-1869.28, lng:-69.30},  {id:17, lat:-1869.28, lng:45.70},
        {id:18, lat:-1869.28, lng:160.70},  {id:19, lat:-1869.28, lng:275.70},
        {id:20, lat:-1869.28, lng:390.70},  {id:21, lat:-1869.28, lng:505.70},
        {id:22, lat:-1984.28, lng:-299.30}, {id:23, lat:-1984.28, lng:-184.30},
        {id:24, lat:-1984.28, lng:-69.30},  {id:25, lat:-1984.28, lng:45.70},
        {id:26, lat:-1984.28, lng:160.70},  {id:27, lat:-1984.28, lng:275.70},
        {id:28, lat:-1984.28, lng:390.70},  {id:29, lat:-1984.28, lng:505.70},
        {id:30, lat:-2099.28, lng:-299.30}, {id:31, lat:-2099.28, lng:-184.30},
        {id:32, lat:-2099.28, lng:-69.30},  {id:33, lat:-2099.28, lng:45.70},
        {id:34, lat:-2099.28, lng:160.70},  {id:35, lat:-2099.28, lng:275.70},
        {id:36, lat:-2099.28, lng:390.70},  {id:37, lat:-2099.28, lng:505.70},
        {id:38, lat:-2214.28, lng:-299.30}, {id:39, lat:-2214.28, lng:-184.30},
        {id:40, lat:-2214.28, lng:-69.30},
        {id:41, lat:-1639.28, lng:750.70},  {id:42, lat:-1639.28, lng:865.70},
        {id:43, lat:-1639.28, lng:980.70},  {id:44, lat:-1639.28, lng:1095.70},
        {id:45, lat:-1754.28, lng:750.70},  {id:46, lat:-1754.28, lng:865.70},
        {id:47, lat:-1754.28, lng:980.70},  {id:48, lat:-1754.28, lng:1095.70},
        {id:49, lat:-1869.28, lng:750.70},  {id:50, lat:-1869.28, lng:865.70},
        {id:51, lat:-1869.28, lng:980.70},  {id:52, lat:-1869.28, lng:1095.70},
        {id:53, lat:-1984.28, lng:750.70},  {id:54, lat:-1984.28, lng:865.70},
        {id:55, lat:-1984.28, lng:980.70},  {id:56, lat:-1984.28, lng:1095.70},
        {id:57, lat:-2099.28, lng:750.70},  {id:58, lat:-2099.28, lng:865.70},
        {id:59, lat:-2099.28, lng:980.70},  {id:60, lat:-2099.28, lng:1095.70},
        {id:61, lat:-2214.28, lng:750.70},  {id:62, lat:-2214.28, lng:865.70},
        {id:63, lat:-2214.28, lng:980.70},  {id:64, lat:-2214.28, lng:1095.70},
        {id:65, lat:-2329.28, lng:750.70},  {id:66, lat:-2329.28, lng:865.70},
        {id:67, lat:-2329.28, lng:980.70},  {id:68, lat:-2329.28, lng:1095.70},
        {id:69, lat:-2444.28, lng:750.70},  {id:70, lat:-2444.28, lng:865.70},
    ];

    const COLORS = {
        marabunta: { bg: '#32a0ff', grad: 'radial-gradient(50% 50% at 50% 50%,rgb(50,230,255),rgb(50,157,255))', border: '#32e6ff' },
        vagos:     { bg: '#ffad32', grad: 'radial-gradient(50% 50% at 50% 50%,rgb(255,198,50),rgb(255,173,50))', border: '#ffc632' },
        families:  { bg: '#31de43', grad: 'radial-gradient(50% 50% at 50% 50%,rgb(94,251,110),rgb(49,222,67))',  border: '#5EFB6E' },
        ballas:    { bg: '#892dae', grad: 'radial-gradient(50% 50% at 50% 50%,rgb(137,57,174),rgb(100,45,155))', border: '#8939AE' },
        bloods:    { bg: '#ff3232', grad: 'radial-gradient(50% 50% at 50% 50%,rgb(255,77,77),rgb(255,50,50))',   border: '#FF6565' },
    };

    function makeIcon(color, inWar, id, zoom) {
        const L = window.L;
        if (!L) return null;
        const z = (zoom != null) ? zoom : 5;
        const size = Math.max(8, Math.round(50 * Math.pow(2, z - 5)));
        const fs = Math.max(6, Math.round(size * 0.26));
        const c = COLORS[color];
        const bgColor  = c ? c.bg   : '#494949';
        const bgImage  = c ? c.grad : 'none';
        const border   = c ? c.border : '#666';
        const inner = inWar
            ? `<div style="width:65%;height:65%;background:#fff;border-radius:50%;"></div>`
            : `<span style="font-size:${fs}px;font-weight:bold;color:#fff;text-shadow:0 1px 2px #000;">${id}</span>`;
        return L.divIcon({
            className: '',
            html: `<div style="width:${size}px;height:${size}px;border-radius:5px;background-color:${bgColor};background-image:${bgImage};border:1px solid ${border};opacity:0.85;display:flex;align-items:center;justify-content:center;">${inner}</div>`,
            iconSize: [size, size],
            iconAnchor: [size/2, size/2]
        });
    }

    function initMarkers() {
        if (!_leafMap || !window.L) return;
        _markers.forEach(m => _leafMap.removeLayer(m));
        _markers = [];
        const z = _leafMap.getZoom();
        SQUARE_POSITIONS.forEach(pos => {
            const info = squaresInfo.find(el => el && el.index === pos.id);
            const color = info ? (info.color || '') : '';
            const inWar = info ? (info.inWar || false) : false;
            const isMySquare = info ? (info.fractionName === myFractionName) : false;
            const icon = makeIcon(color, inWar, pos.id, z);
            if (!icon) return;
            const m = window.L.marker([pos.lat, pos.lng], { icon, interactive: true, zIndexOffset: 1000 }).addTo(_leafMap);
            m.on('click', (e) => {
                const clickX = e.originalEvent ? e.originalEvent.clientX : 300;
                const clickY = e.originalEvent ? e.originalEvent.clientY : 300;

                if (inWar && info) {
                    // InfoCapture делает x/3.5 и y/3.5 — передаём уже умноженные на 3.5
                    // чтобы плашка появилась рядом с курсором
                    infoData = {
                        x: clickX * 3.5,
                        y: clickY * 3.5,
                        idSquare: info.index,
                        isOwner: myFractionName === info.attackGangName,
                        attackGangName: info.attackGangName || '',
                        defendGangName: info.defendGangName || '',
                        countMembers: info.countMembers || 1,
                        calibreIndex: info.calibreIndex || 0,
                        startDate: info.startDate || ''
                    };
                    showInfo = true;
                } else if (isMySquare) {
                    // Свой квадрат — нельзя атаковать
                    return;
                } else {
                    // Чужой квадрат без войны — открываем планирование
                    openBeat({ index: pos.id, fractionName: info ? (info.fractionName || '') : '' });
                }
            });
            _markers.push(m);
        });
        if (!_leafMap._czh) {
            _leafMap._czh = () => {
                const zoom = _leafMap.getZoom();
                _markers.forEach((m, i) => {
                    const pos = SQUARE_POSITIONS[i];
                    if (!pos) return;
                    const info = squaresInfo.find(el => el && el.index === pos.id);
                    m.setIcon(makeIcon(info ? (info.color||'') : '', info ? (info.inWar||false) : false, pos.id, zoom));
                });
            };
            _leafMap.on('zoomend', _leafMap._czh);
        }
    }

    // Точная копия логики из рабочего index.svelte
    function loadLeaflet(cb) {
        if (window.L) { cb(); return; }
        if (!document.getElementById('leaflet-css')) {
            const link = document.createElement('link');
            link.id = 'leaflet-css'; link.rel = 'stylesheet'; link.href = 'leaflet.css';
            document.head.appendChild(link);
        }
        const s = document.createElement('script');
        s.src = 'leaflet.js';
        s.onload = cb;
        s.onerror = () => console.error('leaflet.js not found');
        document.head.appendChild(s);
    }

    $: if (mapAreaEl && !mapShown) showMap();

    function showMap() {
        if (!mapAreaEl) return;
        loadLeaflet(() => {
            const L = window.L;
            if (!L) return;
            if (!_mapDiv) {
                _mapDiv = document.createElement('div');
                _mapDiv.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;background:#161616;z-index:1;';
                mapAreaEl.appendChild(_mapDiv);
                const CUSTOM_CRS = L.extend({}, L.CRS.Simple, {
                    projection: L.Projection.LonLat,
                    scale: z => Math.pow(2, z),
                    distance: (a, b) => Math.sqrt(Math.pow(b.lng-a.lng,2)+Math.pow(b.lat-a.lat,2)),
                    transformation: new L.Transformation(0.01423, 58.89, -0.01423, 119.4),
                    infinite: true
                });
                _leafMap = L.map(_mapDiv, {
                    crs: CUSTOM_CRS, minZoom:2, maxZoom:5, zoom:5,
                    center:[-1984, 100],
                    preferCanvas:true, attributionControl:false, zoomControl:false,
                    scrollWheelZoom:true, doubleClickZoom:false,
                    maxBounds:[[-5000,-5000],[8000,5000]], maxBoundsViscosity:1.0
                });
                L.tileLayer('public/images/map/{z}/{x}x{y}.png', {
                    minZoom:2, maxZoom:5, noWrap:true,
                    updateWhenIdle: true,
                    updateWhenZooming: false,
                    keepBuffer: 2,
                    errorTileUrl:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
                }).addTo(_leafMap);
                initMarkers();
            } else {
                _mapDiv.style.display = 'block';
            }
            if (_leafMap) {
                _leafMap.scrollWheelZoom.enable();
                _leafMap.dragging.enable();
                setTimeout(() => _leafMap.invalidateSize(), 50);
            }
            mapShown = true;
        });
    }

    function hideMap() {
        if (_mapDiv) _mapDiv.style.display = 'none';
        if (_leafMap) {
            _leafMap.scrollWheelZoom.disable();
            _leafMap.dragging.disable();
        }
        mapShown = false;
    }

    async function openBeat(square) {
        beatData = { ...beatData, idSquare: 0 };
        await tick();
        beatData = {
            idSquare: square.index, territoryUnderControl: square.fractionName,
            hour: 0, minute: 0, countMembers: 2,
            armor: false, resist: false, calibreIndex: 0,
            selectedMembers: [], nonSelectedMembers: []
        };
        showBeat = true;
    }

    async function closeBeat() {
        showBeat = false;
        await tick();
        if (_leafMap) {
            _leafMap.scrollWheelZoom.enable();
            _leafMap.dragging.enable();
            setTimeout(() => _leafMap.invalidateSize(), 50);
        }
    }

    function _onLoad(cnt, squares, name) {
        countSquares = cnt;
        try { squaresInfo = JSON.parse(squares); } catch(e) { squaresInfo = []; }
        myFractionName = name || '';
        avaibleAttacks = Math.max(0, 3 - squaresInfo.filter(el => el && el.inWar && el.attackGangName === myFractionName).length);
        avaibleDefends = Math.max(0, 3 - squaresInfo.filter(el => el && el.inWar && el.fractionName === myFractionName).length);
        if (_leafMap) initMarkers();
    }

    function _onMembers(data) {
        try { beatData = { ...beatData, nonSelectedMembers: JSON.parse(data) }; } catch(e) {}
    }

    onMount(() => {
        window.events.addEvent('cef.capture.load', _onLoad);
        // cef.capture.getMembers слушает сам BeatCapture через addListernEvent
        setTimeout(() => executeClient('client.toserver.capture.load'), 400);
    });

    onDestroy(() => {
        window.events.removeEvent('cef.capture.load', _onLoad);
        hideMap();
        if (_mapDiv && _mapDiv.parentNode) _mapDiv.parentNode.removeChild(_mapDiv);
        _mapDiv = null;
        if (_leafMap) { _leafMap.remove(); _leafMap = null; }
        _markers = [];
    });

    $: getPercents = ((countSquares * 100) / 70).toFixed(2);
</script>

<!-- Экран карты — всегда в DOM, скрывается при BeatCapture -->
<section class="cap-screen" style={showBeat ? 'display:none;' : ''}>
    <!-- Карта на весь экран -->
    <div class="cap-map" bind:this={mapAreaEl}>
        {#if showInfo}
            <InfoCapture
                on:close={() => showInfo = false}
                on:open-beat-capture={(e) => { showInfo = false; openBeat(e.detail.square); }}
                x={infoData.x} y={infoData.y}
                isOwner={infoData.isOwner}
                idSquare={infoData.idSquare}
                attackGangName={infoData.attackGangName}
                defendGangName={infoData.defendGangName}
                countMembers={infoData.countMembers}
                calibreIndex={infoData.calibreIndex}
                startDate={infoData.startDate}
            />
        {/if}
    </div>
    <!-- Кнопки поверх карты (без фона-полосы) -->
    <header class="cap-header">
        <button class="cap-back" on:click={() => { hideMap(); setView('Main'); }}>
            <svg width="9" height="14" viewBox="0 0 9 14" fill="none">
                <path d="M0.238905 7.49966L7.58961 13.7933C7.91216 14.0689 8.43473 14.0689 8.75809 13.7933C9.08064 13.5178 9.08064 13.0702 8.75809 12.7946L1.99043 7.00035L8.75728 1.20605C9.07982 0.930496 9.07982 0.482921 8.75728 0.206667C8.43473 -0.0688891 7.91134 -0.0688891 7.5888 0.206667L0.23809 6.50028C-0.0794991 6.77299 -0.079499 7.22759 0.238905 7.49966Z" fill="white"/>
            </svg>
        </button>
        <div class="cap-stat">Контроль: {getPercents}% | {countSquares}/70</div>
        <div class="cap-stat">⚔ {avaibleAttacks}/3</div>
        <div class="cap-stat">🛡 {avaibleDefends}/3</div>
        <button class="cap-bell" on:click={() => showNotif = true}>🔔</button>
    </header>
</section>

{#if showBeat}
    <div class="cap-beat-wrap">
        <BeatCapture
            on:close={closeBeat}
            territoryUnderControl={beatData.territoryUnderControl}
            idSquare={beatData.idSquare}
            hour={beatData.hour}
            minute={beatData.minute}
            countMembers={beatData.countMembers}
            armor={beatData.armor}
            resist={beatData.resist}
            calibreIndex={beatData.calibreIndex}
            propSelectedMembers={beatData.selectedMembers}
            propNonSelectedMembers={beatData.nonSelectedMembers}
        />
    </div>
{/if}

{#if showNotif}
    <NotificationCapture on:close={() => showNotif = false} />
{/if}

<style>
.cap-screen {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    overflow: hidden;
    background: #161616;
}
/* Карта занимает весь экран */
.cap-map {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 1;
    background: #161616;
}
/* Кнопки плавают поверх карты — без фона-полосы */
.cap-header {
    position: absolute;
    top: 8px; left: 8px; right: 8px;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 6px;
    pointer-events: none;
    background: none;
}
.cap-header > * { pointer-events: all; }
.cap-back {
    background: rgba(0,0,0,0.72);
    border: none; border-radius: 6px;
    width: 34px; height: 34px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; flex-shrink: 0;
}
.cap-back:hover { background: rgba(60,60,60,0.9); }
.cap-stat {
    background: rgba(0,0,0,0.72);
    color: #fff; font-size: 12px;
    padding: 5px 10px; border-radius: 6px;
    white-space: nowrap;
}
.cap-bell {
    margin-left: auto;
    background: rgba(0,0,0,0.72);
    border: none; border-radius: 6px;
    width: 34px; height: 34px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; font-size: 15px; flex-shrink: 0;
}
.cap-bell:hover { background: rgba(60,60,60,0.9); }
/* BeatCapture на весь экран планшета */
.cap-beat-wrap {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 20;
    background: #161616;
    overflow-y: auto;
}
.cap-beat-wrap :global(.beat_capture-container) {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    width: 100% !important;
    height: 100% !important;
    min-height: 100% !important;
    overflow-y: auto;
}
</style>
